<app-modal
  [expanded]="isOpen"
  [contentWidth]="contentWidth"
  (close)="closePanel()"
>
  <div class="flex flex-col overflow-scroll">
    <div class="sticky top-0 flex h-12 w-full items-center justify-end">
      <div class="flex h-16 items-center justify-end">
        <mat-slider
          [max]="maxValue"
          [min]="1"
          [step]="0.1"
          aria-label="unit(s)"
          #ngSlider
          ><input
            matSliderThumb
            [value]="initValue"
            (input)="
              onSlide({
                source: ngSliderThumb,
                parent: ngSlider,
                value: ngSliderThumb.value
              })
            "
            #ngSliderThumb="matSliderThumb"
        /></mat-slider>
      </div>

      <div class="ml-2 flex h-8">
        <button
          class="rounded-none bg-white text-gray-400 hover:text-gray-500"
          (click)="_close()"
        >
          <span class="sr-only">Close panel</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="m-2 h-4 w-4"
          >
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <div #panel class="flex">
      <div class="flex w-full items-center justify-center" #panelContent></div>
    </div>
  </div>
</app-modal>
